module.exports = __webpack_public_path__ + "img/qrcode_zl.901ccdc5.png";